export enum GameStatus {
	COMING_SOON = "COMING_SOON",
	PUBLISHED = "PUBLISHED",
}

export const GameStatusOptions = [
	{ value: GameStatus.COMING_SOON, label: "به زودی" },
	{ value: GameStatus.PUBLISHED, label: "منتشر شده" },
] as const;
